import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SharedService {
  comp = { competency: { category: 'Init' } };
  folder = { fileId: '123456789', type: 'abc' };
  file = { _id: '12345', type: 'abc' }
  files = {}

  private newCompetency = new BehaviorSubject(this.comp)
  sharedCompetency = this.newCompetency.asObservable()

  private deletedFolder = new BehaviorSubject(this.folder)
  sharedFolder = this.deletedFolder.asObservable()

  private deletedFiles = new BehaviorSubject(this.file)
  deletedFile = this.deletedFiles.asObservable()

  private deleteFile = new BehaviorSubject(this.files)
  deleteFiles = this.deleteFile.asObservable()

  private fileMark = new Subject<any>();


  constructor() { }

  nextCompetency(comp) {
    console.log("in shared service", comp);
    this.newCompetency.next(comp)
  }
  folderDeleted(folder) {
    console.log('in shared service', folder)
    this.deletedFolder.next(folder)
  }
  fileDeleted(file) {
    console.log('in shared service file ', file)
    this.deletedFiles.next(file)
  }
  fileDelete(file) {
    console.log('in shared service file ', file)
    this.deleteFile.next(file)
  }

  markasReadFile(data) {
    this.fileMark.next(data)
  }

  filemarkObservable(): Observable<any> {
    return this.fileMark.asObservable();
  }

}
